import React from 'react';
import { SyncIcon } from '../../../content/svg-component';
import './resetFilter.scss';

const ResetFilter = (props) => {
  const { handleReset, placement = 'large-space', parentClassName } = props;
  return (
    <div
      className={`${
        placement === 'small-space'
          ? 'col-1'
          : placement === 'identify'
          ? 'col-sm-1 col-3'
          : 'col-sm-1 col-2'
      } ${parentClassName} h-100 p-0 d-flex flex-row justify-content-center`}
      onClick={handleReset}
    >
      <div
        className={`${
          placement === 'small-space'
            ? 'col-xxl-10 col-lg-11 col-10'
            : 'col-xxl-9 col-10'
        } p-0 d-flex flex-row justify-content-end align-items-center`}
      >
        <div className="bg-white h-100 d-flex flex-row justify-content-center align-items-center border default-border-radius-small cursor-pointer mx-xl-1 icon-box">
          <SyncIcon
            color={'#3d4a8f'}
            variant="svg-md-small svg-sm-small svg-xs-small svg-tiny"
          />
        </div>
      </div>
    </div>
  );
};

export default ResetFilter;
